import React, { useState, useEffect, useRef } from "react";
import InputField from "../../../../DesignSystem/Inputs/InputField";
import DateField from "../../../../DesignSystem/Inputs/DateField";
import MobileNumberInput from "../../../../DesignSystem/Inputs/MobileNumberInput";
import YesNoRadio from "../RadioButton";
import RadioButtonGrid from "../RadioButtonGrid";
import writeDataS1 from "../../../../../backend/Recruitment/Sections/Section1/writeDataS1";
import "react-datepicker/dist/react-datepicker.css";
import { getDataS1 } from "../../../../../backend/Recruitment/Sections/Section1/readDataS1";
import AlertBanner from "../../../../DesignSystem/AlertBanner/AlertBanner";
import PrimaryButton from "../../../../DesignSystem/Buttons/PrimaryButton";
import { formatDateValue } from "../Utils/dateFormatting";
import errorTrackerV2 from "../Validation/Utils/ErrorTrackerV2";
import CheckBoxGrid from "../../../../DesignSystem/Inputs/CheckboxGrid";
import "../../../../../css/Recruitment/Sections.css";
import {
  addSubmissionListener,
  getIsSubmitted,
} from "../../Utils/submissionListener";
import { auth } from "../../../../../backend/firebaseConfig";
import { validateSection1 } from "../Validation/section1";
import { useSelectedUid } from "../../Utils/useSelectedUid";
import { getSelectedUid } from "../../../Applications/Utils/UidListener";


const isValidDate = (d) => d instanceof Date && !isNaN(d.getTime());

const sameDay = (a, b) => {
  if (!isValidDate(a) || !isValidDate(b)) return false;
  return a.toDateString() === b.toDateString();
};

const buildFiveYearsAgo = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 5);
  // optional: normalize time
  d.setHours(0, 0, 0, 0);
  return d;
};

const makeEmptyPrevRow = (toDate) => ({
  address: "",
  address2: "",
  town: "",
  county: "",
  postcode: "",
  from: "",
  to: toDate || "",
});

// shallow compare rows enough for our needs
const rowsEqual = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const A = a[i] || {};
    const B = b[i] || {};
    const keys = ["address", "address2", "town", "county", "postcode"];
    for (const k of keys) {
      if ((A[k] || "") !== (B[k] || "")) return false;
    }
    // compare dates by day
    const aFrom = isValidDate(A.from) ? A.from : "";
    const bFrom = isValidDate(B.from) ? B.from : "";
    const aTo = isValidDate(A.to) ? A.to : "";
    const bTo = isValidDate(B.to) ? B.to : "";

    if (aFrom === "" && bFrom !== "") return false;
    if (aFrom !== "" && bFrom === "") return false;
    if (aFrom !== "" && !sameDay(aFrom, bFrom)) return false;

    if (aTo === "" && bTo !== "") return false;
    if (aTo !== "" && bTo === "") return false;
    if (aTo !== "" && !sameDay(aTo, bTo)) return false;
  }
  return true;
};

const indexedObjectToArray = (obj) => {
  if (!obj || typeof obj !== "object") return [];
  return Object.keys(obj)
    .sort((a, b) => Number(a) - Number(b))
    .map((k) => obj[k]);
};

const normaliseApplyingAs = (v) =>
  Array.isArray(v) ? v : typeof v === "string" && v ? [v] : [];


const Section1 = ({ onValidationStatusChange }) => {
  // const { uid, isApproved, isReady } = useSelectedUid();
  const userId = getSelectedUid();
  const [formData, setFormData] = useState(
    {
      personalDetails: {
        title: "",
        surname: "",
        forename: "",
        otherNames: "",
        formerNames: "",
        nameChangeDate: "",
        reasonForNameChange: "",
        homeTelephone: "",
        officeTelephone: "",
        mobileTelephone: "",
        postAppointmentMobileTelephone: "",
        postAppointmentEmailAddress: "",
        emailAddress: "",
        useSameDeatilsPostAppointment: "",
        currentAddress: "",
        currentAddressLine2: "",
        currentTown: "",
        currentCounty: "",
        currentPostcode: "",
        movingInDate: "",
        dob: "",
        consent: "",
        nationalInsuranceNumber: "",
        nationalityAtBirth: "",
        townOfBirth: "",
        countryOfBirth: "",
        durationInUk: "",
        mothersMaidenName: "",
        consentToDisclosureScotlandCheck: "",
        tempNationalInsuranceNumber: "",
        changedNationality: "",
      },
      previousAddress: [
        // {
        //   address: "",
        //   town: "",
        //   county: "",
        //   postcode: "",
        //   from: "",
        //   to: "",
        // },
      ],

      nextOfKinDetails: {
        name: "",
        address: "",
        town: "",
        county: "",
        postcode: "",
        email: "",
        telephone: "",
        relationship: "",
      },
      applicationDetails: {
        applyingAs: [],
        applyingToJoin: "",
        businessAreas: [],
        ARBusinessAreas: [],
        tradingStyle: "",
        referredBusiness: "",
        referredBusinessDetails: "",
        pensionTransferBusiness: "",
        mortgagePlanningBusiness: "",
      },
    },
    [],
  );

  const [isSubmitted, setIsSubmitted] = useState(getIsSubmitted());

  useEffect(() => {
    const removeListener = addSubmissionListener(setIsSubmitted);
    setIsSubmitted(getIsSubmitted());
    return () => removeListener();
  }, []);


  const handleARBusinessAreasCheckboxChange = (e, section, option) => {
    const isChecked = e.target.checked;

    setFormData((prevData) => {
      let updatedARBusinessAreas = Array.isArray(
        prevData.applicationDetails.ARBusinessAreas,
      )
        ? [...prevData.applicationDetails.ARBusinessAreas]
        : [];

      // Add or remove the option based on its checked status
      if (isChecked) {
        if (!updatedARBusinessAreas.includes(option)) {
          updatedARBusinessAreas.push(option); // Add option to the array
        }
      } else {
        updatedARBusinessAreas = updatedARBusinessAreas.filter(
          (selectedOption) => selectedOption !== option,
        ); // Remove option from the array
      }

      return {
        ...prevData,
        applicationDetails: {
          ...prevData.applicationDetails,
          ARBusinessAreas: updatedARBusinessAreas,
        },
      };
    });
  };
  const handleBusinessAresaCheckboxChange = (e, section, option) => {
    const isChecked = e.target.checked;

    setFormData((prevData) => {
      let updatedBusinessAreas = Array.isArray(
        prevData.applicationDetails.businessAreas,
      )
        ? [...prevData.applicationDetails.businessAreas]
        : [];

      // Add or remove the option based on its checked status
      if (isChecked) {
        if (!updatedBusinessAreas.includes(option)) {
          updatedBusinessAreas.push(option); // Add option to the array
        }
      } else {
        updatedBusinessAreas = updatedBusinessAreas.filter(
          (selectedOption) => selectedOption !== option,
        ); // Remove option from the array
      }

      return {
        ...prevData,
        applicationDetails: {
          ...prevData.applicationDetails,
          businessAreas: updatedBusinessAreas,
        },
      };
    });
  };

  const fetchUserData = async () => {
    try {
      // console.log("[Section1] Fetching user data...");
      const userData = await getDataS1();

      if (!userData) {
        // console.warn("[Section1] No user data returned");
        return;
      }

      // console.log("[Section1] User data received:", userData);

      const {
        personalDetails,
        previousAddress,
        nextOfKinDetails,
        applicationDetails,
      } = userData;

      // console.log("[Section1] Previous address:", previousAddress);

    const rawPrev = previousAddress; // could be array OR object {0:{...}}
const prevArray = Array.isArray(rawPrev)
  ? rawPrev
  : indexedObjectToArray(rawPrev);

const formattedPreviousAddress = prevArray.map((address) => ({
  ...makeEmptyPrevRow(""),
  address: address?.address || "",
  address2: address?.address2 || "",
  town: address?.town || "",
  county: address?.county || "",
  postcode: address?.postcode || "",
  from: address?.from?.seconds ? new Date(address.from.seconds * 1000) : "",
  to: address?.to?.seconds ? new Date(address.to.seconds * 1000) : "",
}));


      const formattedPersonalDetails = {
        ...personalDetails,
        movingInDate: personalDetails.movingInDate
          ? new Date(personalDetails.movingInDate.seconds * 1000)
          : "",

        nameChangeDate: personalDetails.nameChangeDate
          ? new Date(personalDetails.nameChangeDate.seconds * 1000)
          : "",

        dob: personalDetails.dob
          ? new Date(personalDetails.dob.seconds * 1000)
          : "",

        durationInUk: personalDetails.durationInUk
          ? new Date(personalDetails.durationInUk.seconds * 1000)
          : "",
      };
      setFormData((prevFormData) => ({
        personalDetails: formattedPersonalDetails,
        previousAddress: formattedPreviousAddress,
        nextOfKinDetails: { ...nextOfKinDetails },
        applicationDetails: {
          ...applicationDetails,
          applyingAs: normaliseApplyingAs(applicationDetails?.applyingAs),
          businessAreas: applicationDetails.businessAreas || [],
          ARBusinessAreas: applicationDetails.ARBusinessAreas || [],
        },
      }));
      // console.log("[Section1] Form data set successfully:", formData);
      // onValidationStatusChange(true);
    } catch (error) {
      // console.error("[Section1] Error in fetchUserData:", error);
    }
  };

  useEffect(() => {
    if (!userId) {
      // console.log("[Section1] UID not ready yet, waiting...");
      return; // Wait until UID is ready
    }

    // console.log("[Section1] UID is ready, fetching data for:", userId);
    fetchUserData();
    validateForm();
  }, [userId]);

  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const sectionTopRef = useRef(null);

  const options_1_5 = ["Non-Selling Principal", "Selling Principal", "Adviser"];

  const tooltips_1_5 = [
    "You are the principal (a director) of the business, but you will not be advising.",
    "You are the principal (a director) of the business, and you will be advising.",
    "You are an adviser, who is not a director of the business.",
  ];

  const options_1_6 = [
    "Mortgages",
    "Protection",
    "General Insurance",
    "Financial Planning",
    "Long Term Care",
    "Equity Release",
  ];
  const options_1_7 = [
    "An Existing Appointed Representative",
    "A New Appointed Representative",
    "Trading Style",
  ];

  const tooltips_1_7 = [
    "You want to join an existing Appointed Representative of Rosemount Financial Solutions (IFA) Ltd. You can find a list of these on the FCA register by clicking here.",
    "You want to join as a new Appointed Representative, which is not currently trading under Rosemount Financial Solutions (IFA) Ltd. You can find a list of our existing AR’s by clicking here.",
    "You wish to operate under Rosemount Financial Solutions (IFA) Ltd using a trading name for your business.",
  ];

  const [missingPeriods, setMissingPeriods] = useState([]);

  const addPreviousAddress = (startFrom, toDate) => {
    setFormData((prevData) => {
      const updatedPreviousAddress = [
        ...prevData.previousAddress,
        {
          address: "",
          town: "",
          county: "",
          postcode: "",
          from: startFrom || "", // Store the Date object directly
          to: toDate || "",
        },
      ];
      return { ...prevData, previousAddress: updatedPreviousAddress };
    });
  };

  const deleteLastPreviousAddress = () => {
    setFormData((prev) => {
      const rows = [...(prev.previousAddress || [])];
      if (rows.length <= 1) return prev; // keep minimum 1 when required
      rows.pop();
      return { ...prev, previousAddress: rows };
    });
  };

  const handlePreviousAddressChange = (eOrDate, index, name) => {
    const isDate = eOrDate instanceof Date;
    const value = isDate ? eOrDate : eOrDate.target.value;

    setFormData((prev) => {
      const updated = [...prev.previousAddress];
      updated[index] = {
        ...updated[index],
        [name]: isDate ? value : value,
      };

      return { ...prev, previousAddress: updated };
    });
  };

  const handleChange = (e, section, index = null, name = null) => {
    const isDate = e instanceof Date;
    const value = isDate ? e : e.target.value;
    name = isDate ? name : e.target.name;

    setFormData((prevData) => {
      const updatedData = { ...prevData };
      if (section === "previousAddress" && index !== null) {
        updatedData.previousAddress[index][name] = value;
      } else {
        updatedData[section][name] = value;
      }
      return updatedData;
    });
    // console.log("Data");
    // console.log(formData);
    validateField(section, name, value);
  };

  const validateField = (section, name, value) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      // Handle special validation for applyingAs array
      if (name === "applyingAs") {
        updatedErrors[`${section}.${name}`] =
          "At least one option must be selected.";
      } else if (
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        value === undefined
      ) {
        updatedErrors[`${section}.${name}`] = "This field is required.";
      } else {
        delete updatedErrors[`${section}.${name}`];
      }

      return updatedErrors;
    });
  };

  const validateForm = () => {
    const formErrors = validateSection1(formData);

    // console.log("Section 1 Validation Errors:", formErrors);
    // console.log("Error Count:", Object.keys(formErrors).length);

    setErrors(formErrors);
    errorTrackerV2.setSectionErrors("section1", formErrors);

    const ok = Object.keys(formErrors).length === 0;
    onValidationStatusChange(ok);
    setIsValid(ok);
  };
  useEffect(() => {
    validateForm();
  }, [formData]);

  // useEffect(() => {
  //   console.log(shouldBypassValidation(auth.currentUser?.uid));
  // }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    sectionTopRef.current?.scrollIntoView({ behavior: "smooth" });
    setShowErrors(true);

    // Save data regardless of validation status
    writeDataS1(formData);

    // Show appropriate alert based on validation result
    if (isValid) {
      // console.log(formData);
      setAlertMessage("Data saved successfully!");
      setAlertType("success");
    } else {
      setAlertMessage(
        "Data saved with errors. Please review the fields marked with errors.",
      );
      setAlertType("alert");
    }
  };
  const fiveYearsAgo = buildFiveYearsAgo();
  const movingInDate = formData.personalDetails.movingInDate;
  const needsPrev = isValidDate(movingInDate) && movingInDate > fiveYearsAgo;

  const canDeletePrev =
    needsPrev && (formData.previousAddress?.length || 0) > 1;

  // First useEffect to add a single initial entry when movingInDate changes
  useEffect(() => {
    const movingInDate = formData.personalDetails.movingInDate;
    const fiveYearsAgo = buildFiveYearsAgo();

    setFormData((prev) => {
      const m = prev.personalDetails.movingInDate;

      // no movingInDate OR older than 5 years => no previous addresses required
      if (!isValidDate(m) || m <= fiveYearsAgo) {
        if (prev.previousAddress?.length) {
          return { ...prev, previousAddress: [] };
        }
        return prev;
      }

      // We need previous addresses (moving in within 5 years)
      let rows = Array.isArray(prev.previousAddress)
        ? [...prev.previousAddress]
        : [];

      // ensure at least 1 row exists
      if (rows.length === 0) rows = [makeEmptyPrevRow(m)];

      // 1) force cascade "to" dates
      rows = rows.map((row, idx) => {
        const desiredTo = idx === 0 ? m : rows[idx - 1]?.from;
        const desiredToDate = isValidDate(desiredTo) ? new Date(desiredTo) : "";
        return {
          ...makeEmptyPrevRow(""), // ensure missing keys exist
          ...row,
          to: desiredToDate,
        };
      });

      // 2) auto-add ONE more row if last.from is set and still within 5 years
      const last = rows[rows.length - 1];
      const lastFrom = isValidDate(last?.from) ? last.from : null;

      if (lastFrom && lastFrom > fiveYearsAgo) {
        // if user has provided from and we're still inside 5 years, we need another row
        rows.push(makeEmptyPrevRow(new Date(lastFrom)));
      }

      // 3) auto-trim extra rows:
      // If we have trailing empty rows beyond the needed one, remove them.
      // Keep at most ONE trailing "empty" row.
      const isRowBlank = (r) =>
        !isValidDate(r?.from) &&
        !String(r?.address || "").trim() &&
        !String(r?.town || "").trim() &&
        !String(r?.county || "").trim() &&
        !String(r?.postcode || "").trim() &&
        !String(r?.address2 || "").trim();

      // remove multiple blank rows at the end
      while (
        rows.length > 1 &&
        isRowBlank(rows[rows.length - 1]) &&
        isRowBlank(rows[rows.length - 2])
      ) {
        rows.pop();
      }

      // If the last.from is <= fiveYearsAgo then we don't need a trailing empty row
      // (because coverage has reached 5 years)
      const newLast = rows[rows.length - 1];
      const newLastFrom = isValidDate(newLast?.from) ? newLast.from : null;
      if (newLastFrom && newLastFrom <= fiveYearsAgo) {
        // If there is a blank row after this condition, it would have already been added,
        // so remove it.
        // In practice this triggers when the user edits a from date to older than 5 years.
        // Ensure we don't end with an extra blank.
        while (rows.length > 1 && isRowBlank(rows[rows.length - 1])) rows.pop();
      }

      if (rowsEqual(prev.previousAddress, rows)) return prev;
      return { ...prev, previousAddress: rows };
    });
  }, [
    formData.personalDetails.movingInDate,
    // re-run when ANY from-date changes (but not every keystroke in address fields)
    JSON.stringify(
      (formData.previousAddress || []).map((r) =>
        isValidDate(r?.from) ? r.from.toISOString().slice(0, 10) : "",
      ),
    ),
  ]);

  // Second useEffect to add more previous addresses based on `from` date of the last entry
  // useEffect(() => {
  //   if (formData.previousAddress.length > 0) {
  //     const fiveYearsAgo = new Date();
  //     fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5);

  //     // Get the last address added and check if it's within 5 years from today
  //     const lastAddress =
  //       formData.previousAddress[formData.previousAddress.length - 1];
  //     const lastFromDate = lastAddress.from ? new Date(lastAddress.from) : null;

  //     // Ensure the user has entered the 'from' date for the last address and it is within 5 years
  //     if (lastFromDate && lastFromDate > fiveYearsAgo) {
  //       const nextToDate = new Date(lastFromDate);

  //       addPreviousAddress(null, nextToDate); // Add a new entry with only the 'to' date set
  //     }
  //   }
  // }, [formData.previousAddress]);

  return (
    <form className="section-form" noValidate ref={sectionTopRef}>
      {alertMessage && (
        <AlertBanner
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertMessage("")}
        />
      )}
      <h3>Section 1 - Applicant Details</h3>
      {/* 1.1 Full Name */}
      <div className="form-row">
        <div className="Content">
          1.1 Full name <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <InputField
            id="title"
            placeholder="Title"
            error={showErrors && !!errors[`personalDetails.title`]}
            helperText={showErrors ? errors[`personalDetails.title`] : ""}
            value={formData.personalDetails.title}
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
          <InputField
            id="surname"
            placeholder="Surname"
            error={showErrors && !!errors[`personalDetails.surname`]}
            helperText={showErrors ? errors[`personalDetails.surname`] : ""}
            value={formData.personalDetails.surname}
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
          <InputField
            id="forename"
            placeholder="Forename"
            error={showErrors && !!errors[`personalDetails.forename`]}
            helperText={showErrors ? errors[`personalDetails.forename`] : ""}
            value={formData.personalDetails.forename}
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
          <InputField
            id="otherNames"
            placeholder="Other Names (if any)"
            value={formData.personalDetails.otherNames}
            onChange={(e) => handleChange(e, "personalDetails")}
          />
        </div>
      </div>
      {/* 1.2 Previous Name */}
      <div className="form-row">
        <div className="Content">
          1.2 Previous Name – if you are known, or have been known, by any other
          names or have a former name (s), or surname (s), please enter full
          details
        </div>

        <div className="input-group input-group--grid-2col">
          <InputField
            id="formerNames"
            placeholder="Former name(s)"
            value={formData.personalDetails.formerNames}
            onChange={(e) => handleChange(e, "personalDetails")}
            required={formData.personalDetails.formerNames !== ""}
          />

          <DateField
            id="nameChangeDate"
            label="Date of Name Change"
            value={formatDateValue(formData.personalDetails.nameChangeDate)}
            error={
              formData.personalDetails.formerNames !== "" &&
              !formData.personalDetails.nameChangeDate
            }
            helperText={
              formData.personalDetails.formerNames !== "" &&
              !formData.personalDetails.nameChangeDate
                ? "This field is required"
                : ""
            }
            onChange={(e) =>
              handleChange(
                {
                  target: {
                    name: "nameChangeDate",
                    value: e.target.value ? new Date(e.target.value) : "",
                  },
                },
                "personalDetails",
              )
            }
          />

          <InputField
            id="reasonForNameChange"
            placeholder="Reason for name change"
            value={formData.personalDetails.reasonForNameChange}
            error={
              formData.personalDetails.formerNames !== "" &&
              typeof formData.personalDetails.reasonForNameChange ===
                "string" &&
              formData.personalDetails.reasonForNameChange.trim() === ""
            }
            helperText={
              formData.personalDetails.formerNames !== "" &&
              typeof formData.personalDetails.reasonForNameChange ===
                "string" &&
              formData.personalDetails.reasonForNameChange.trim() === ""
                ? "This field is required"
                : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required={formData.personalDetails.formerNames !== ""}
            multiline
            rows={2}
          />
        </div>
      </div>
      {/* 1.3 Contact Details */}
      <div className="form-row">
        <div className="Content">
          1.3 Contact details <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <MobileNumberInput
            id="mobileTelephone"
            label="Mobile Telephone"
            value={formData.personalDetails.mobileTelephone}
            onChange={(phone) =>
              handleChange(
                {
                  target: {
                    name: "mobileTelephone",
                    value: phone || "",
                  },
                },
                "personalDetails",
              )
            }
            isRequired
            disabled={false}
            error={showErrors ? errors["personalDetails.mobileTelephone"] : ""}
          />

          <InputField
            label="Email Address"
            id="emailAddress"
            type="email"
            placeholder="Email Address"
            value={formData.personalDetails.emailAddress}
            error={showErrors && !!errors[`personalDetails.emailAddress`]}
            helperText={
              showErrors ? errors[`personalDetails.emailAddress`] : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
          <MobileNumberInput
            id="homeTelephone"
            label="Home Telephone"
            value={formData.personalDetails.homeTelephone}
            onChange={(phone) =>
              handleChange(
                {
                  target: {
                    name: "homeTelephone",
                    value: phone || "",
                  },
                },
                "personalDetails",
              )
            }
            // isRequired
            error={showErrors ? errors["personalDetails.homeTelephone"] : ""}
          />

          <MobileNumberInput
            id="officeTelephone"
            label="Office Telephone"
            value={formData.personalDetails.officeTelephone}
            onChange={(phone) =>
              handleChange(
                {
                  target: {
                    name: "officeTelephone",
                    value: phone || "",
                  },
                },
                "personalDetails",
              )
            }
            // isRequired
            error={showErrors ? errors["personalDetails.officeTelephone"] : ""}
          />
        </div>
        {/* </div>
      <div className="form-row"> */}
        <div className="input-group-row">
          <div className="Content">
            Can we use same contact details for post-appointment communication?
            <span style={{ color: "var(--Error)" }}>*</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="useSameDeatilsPostAppointment"
              value={formData.personalDetails.useSameDeatilsPostAppointment}
              onChange={(e) => handleChange(e, "personalDetails")}
              error={
                showErrors
                  ? errors["personalDetails.useSameDeatilsPostAppointment"]
                  : ""
              }
            />
          </div>
        </div>
        {formData.personalDetails.useSameDeatilsPostAppointment === false ? (
          <div className="form-row">
            <div className="Content">Please provide Contact details</div>
            <div className="input-group">
              <MobileNumberInput
                id="postAppointmentMobileTelephone"
                label="Mobile Telephone"
                value={formData.personalDetails.postAppointmentMobileTelephone}
                onChange={(phone) =>
                  handleChange(
                    {
                      target: {
                        name: "postAppointmentMobileTelephone",
                        value: phone || "",
                      },
                    },
                    "personalDetails",
                  )
                }
                isRequired
                disabled={false}
                error={
                  showErrors
                    ? errors["personalDetails.postAppointmentMobileTelephone"]
                    : ""
                }
              />

              <InputField
                id="postAppointmentEmailAddress"
                type="email"
                label={"Email Address"}
                placeholder="Email Address"
                value={formData.personalDetails.postAppointmentEmailAddress}
                error={
                  showErrors &&
                  !!errors[`personalDetails.postAppointmentEmailAddress`]
                }
                helperText={
                  showErrors
                    ? errors[`personalDetails.postAppointmentEmailAddress`]
                    : ""
                }
                onChange={(e) => handleChange(e, "personalDetails")}
                required
              />
            </div>
          </div>
        ) : null}
      </div>
      {/* <h4>
        POST APPOINTMENT CONTACT DETAILS - This will be used for all future
        communication
      </h4> */}
      <div className="form-row">
        <div className="Content">
          1.4(a) Current Address{" "}
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group input-group--grid-2col">
          <InputField
            id="currentAddress"
            placeholder="Address Line 1"
            value={formData.personalDetails.currentAddress}
            error={showErrors && !!errors[`personalDetails.currentAddress`]}
            helperText={
              showErrors ? errors[`personalDetails.currentAddress`] : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
          <InputField
            id="currentCounty"
            placeholder="County"
            value={formData.personalDetails.currentCounty}
            error={showErrors && !!errors[`personalDetails.currentCounty`]}
            helperText={
              showErrors ? errors[`personalDetails.currentCounty`] : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
          <InputField
            id="currentAddressLine2"
            placeholder="Address Line 2"
            value={formData.personalDetails.currentAddressLine2}
            onChange={(e) => handleChange(e, "personalDetails")}
          />{" "}
          <div className="input-group">
            <InputField
              id="currentPostcode"
              placeholder="Postcode"
              value={formData.personalDetails.currentPostcode}
              error={showErrors && !!errors[`personalDetails.currentPostcode`]}
              helperText={
                showErrors ? errors[`personalDetails.currentPostcode`] : ""
              }
              onChange={(e) => handleChange(e, "personalDetails")}
              required
            />
          </div>
          <InputField
            id="currentTown"
            placeholder="Town/City"
            value={formData.personalDetails.currentTown}
            error={showErrors && !!errors[`personalDetails.currentTown`]}
            helperText={showErrors ? errors[`personalDetails.currentTown`] : ""}
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
        </div>

        <div className="input-group-row">
          <div className="Content">
            Date you moved into your current address{" "}
            <span style={{ color: "var(--Error)" }}>*</span>
          </div>
          <div className="input-group">
            <DateField
              id="movingInDate"
              placeholder="From"
              value={formatDateValue(formData.personalDetails.movingInDate)}
              onChange={(e) =>
                handleChange(
                  {
                    target: {
                      name: "movingInDate",
                      value: e.target.value ? new Date(e.target.value) : "",
                    },
                  },
                  "personalDetails",
                )
              }
              error={showErrors && !!errors[`personalDetails.movingInDate`]}
              helperText={
                showErrors ? errors[`personalDetails.movingInDate`] : ""
              }
            />
          </div>
        </div>
      </div>
      {(() => {
        const fiveYearsAgo = new Date();
        fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5);
        const movingInDate = formData.personalDetails.movingInDate
          ? new Date(formData.personalDetails.movingInDate)
          : null;
        return movingInDate &&
          movingInDate > fiveYearsAgo &&
          formData.previousAddress.length > 0 ? (
          <>
            <div className="form-row">
              <div className="Content">1.4(b) Previous Address(es)</div>
              {/* {formData.previousAddress.length > 0 && (
                <button
                  type="button"
                  className="icon-button delete-button"
                  onClick={() => deleteLastPreviousAddress()}
                  disabled={movingInDate && movingInDate > fiveYearsAgo}
                  title="Delete last address"
                >
                  <i className="fas fa-trash"></i>
                </button>
              )} */}
            </div>
            <div className="form-row">
              <div className="Content">
                If you have not resided at your current address for more than
                five years, please enter previous addresses and dates at this
                address.
              </div>
              <div className="input-group">
                {formData.previousAddress.map((address, index) => (
                  <div
                    key={index}
                    className="input-group input-group--address-grid"
                  >
                    <div className="address-column address-column--left">
                      <InputField
                        id={`address-${index}`}
                        placeholder="Address Line 1"
                        value={address?.address || ""}
                        error={
                          showErrors &&
                          !!errors[`previousAddress.${index}.address`]
                        }
                        helperText={
                          showErrors
                            ? errors[`previousAddress.${index}.address`]
                            : ""
                        }
                        onChange={(e) =>
                          handlePreviousAddressChange(e, index, "address")
                        }
                      />
                      <InputField
                        id={`address2-${index}`}
                        placeholder="Address Line 2"
                        value={address?.address2 || ""}
                        onChange={(e) =>
                          handlePreviousAddressChange(e, index, "address2")
                        }
                      />
                      <InputField
                        id={`town-${index}`}
                        placeholder="Town/City"
                        value={address?.town || ""}
                        error={
                          showErrors &&
                          !!errors[`previousAddress.${index}.town`]
                        }
                        helperText={
                          showErrors
                            ? errors[`previousAddress.${index}.town`]
                            : ""
                        }
                        onChange={(e) =>
                          handlePreviousAddressChange(e, index, "town")
                        }
                      />
                    </div>
                    <div className="address-column address-column--right">
                      <InputField
                        id={`county-${index}`}
                        placeholder="Country"
                        value={address?.county || ""}
                        error={
                          showErrors &&
                          !!errors[`previousAddress.${index}.county`]
                        }
                        helperText={
                          showErrors
                            ? errors[`previousAddress.${index}.county`]
                            : ""
                        }
                        onChange={(e) =>
                          handlePreviousAddressChange(e, index, "county")
                        }
                      />
                      <InputField
                        id={`postcode-${index}`}
                        placeholder="Postcode"
                        value={address?.postcode || ""}
                        error={
                          showErrors &&
                          !!errors[`previousAddress.${index}.postcode`]
                        }
                        helperText={
                          showErrors
                            ? errors[`previousAddress.${index}.postcode`]
                            : ""
                        }
                        onChange={(e) =>
                          handlePreviousAddressChange(e, index, "postcode")
                        }
                      />
                      <div className="input-group">
                        <DateField
                          id={`from-${index}`}
                          placeholder="From"
                          value={formatDateValue(address?.from)}
                          onChange={(e) =>
                            handlePreviousAddressChange(
                              e.target.value ? new Date(e.target.value) : "",
                              index,
                              "from",
                            )
                          }
                        />

                        <DateField
                          id={`to-${index}`}
                          placeholder="To"
                          value={formatDateValue(address?.to)}
                          disabled={true}
                          error={
                            showErrors &&
                            !!errors[`previousAddress.${index}.to`]
                          }
                          helperText={
                            showErrors
                              ? errors[`previousAddress.${index}.to`]
                              : ""
                          }
                          onChange={(e) =>
                            handlePreviousAddressChange(
                              { target: { value: new Date(e.target.value) } },
                              index,
                              "to",
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))}
                {canDeletePrev && (
                  <div className="button-group">
                    <button
                      type="button"
                      className="icon-button delete-button"
                      onClick={deleteLastPreviousAddress}
                      title="Delete last address"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : null;
      })()}
      <div className="input-group-row">
        <div className="Content">
          1.5 Date of Birth
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <DateField
            id="dob"
            placeholder="Date of Birth"
            value={formatDateValue(formData.personalDetails.dob)}
            error={showErrors && !!errors["personalDetails.dob"]}
            helperText={showErrors ? errors["personalDetails.dob"] : ""}
            onChange={(e) =>
              handleChange(
                { target: { name: "dob", value: new Date(e.target.value) } },
                "personalDetails",
              )
            }
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.6 Please confirm that you give consent for a Disclosure and Barring
          Service (DBS check)
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <YesNoRadio
            name="consentToDisclosureScotlandCheck"
            value={formData.personalDetails.consentToDisclosureScotlandCheck}
            error={
              showErrors
                ? errors[`personalDetails.consentToDisclosureScotlandCheck`]
                : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.7 National Insurance Number{" "}
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <InputField
            id="nationalInsuranceNumber"
            value={formData.personalDetails.nationalInsuranceNumber}
            placeholder="National Insurance Number"
            error={
              showErrors && !!errors[`personalDetails.nationalInsuranceNumber`]
            }
            helperText={
              showErrors
                ? errors[`personalDetails.nationalInsuranceNumber`]
                : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
        </div>
        {/* </div>
      <div className="input-group-row"> */}
        <div className="Content">
          If you have a temporary National Insurance number, have you applied
          for a permanent number?
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <YesNoRadio
            name="tempNationalInsuranceNumber"
            value={formData.personalDetails.tempNationalInsuranceNumber}
            onChange={(e) => {
              handleChange(e, "personalDetails");
            }}
            na={true}
            required={true}
            error={
              showErrors
                ? errors[`personalDetails.tempNationalInsuranceNumber`]
                : ""
            }
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.8 Nationality at birth{" "}
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <InputField
            id="nationalityAtBirth"
            value={formData.personalDetails.nationalityAtBirth}
            placeholder="Nationality"
            error={showErrors && !!errors[`personalDetails.nationalityAtBirth`]}
            helperText={
              showErrors ? errors[`personalDetails.nationalityAtBirth`] : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
        </div>
      </div>{" "}
      <div className="Label-Small-SemiBold">
        NB: If you are not British, nor an EU citizen, please provide proof of
        indefinite right to remain and work in the UK. Acceptable proof is your
        original passport or original correspondence from the Home Office.
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.9 Have you changed your nationality since birth, if so please
          provide your current nationality
        </div>
        <div className="input-group">
          <InputField
            id="changedNationality"
            value={formData.personalDetails.changedNationality}
            placeholder="Changed Nationality"
            onChange={(e) => handleChange(e, "personalDetails")}
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.10 Town of Birth
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <InputField
            id="townOfBirth"
            value={formData.personalDetails.townOfBirth}
            placeholder="Town"
            error={showErrors && !!errors[`personalDetails.townOfBirth`]}
            helperText={showErrors ? errors[`personalDetails.townOfBirth`] : ""}
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.11 Country of Birth
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <InputField
            id="countryOfBirth"
            value={formData.personalDetails.countryOfBirth}
            placeholder="Country"
            error={showErrors && !!errors[`personalDetails.countryOfBirth`]}
            helperText={
              showErrors ? errors[`personalDetails.countryOfBirth`] : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.12 If you were born outside the EU, please enter the date you first
          started living in the UK
        </div>
        <div className="input-group">
          <DateField
            id="durationInUk"
            placeholder="Duration in UK"
            value={formatDateValue(formData.personalDetails.durationInUk)}
            error={showErrors && !!errors[`personalDetails.durationInUk`]}
            helperText={
              showErrors ? errors[`personalDetails.durationInUk`] : ""
            }
            onChange={(e) =>
              handleChange(
                {
                  target: {
                    name: "durationInUk",
                    value: new Date(e.target.value),
                  },
                },
                "personalDetails",
              )
            }
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.13 Mother’s maiden name
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <InputField
            id="mothersMaidenName"
            value={formData.personalDetails.mothersMaidenName}
            placeholder="Mother's Maiden Name"
            error={showErrors && !!errors[`personalDetails.mothersMaidenName`]}
            helperText={
              showErrors ? errors[`personalDetails.mothersMaidenName`] : ""
            }
            onChange={(e) => handleChange(e, "personalDetails")}
            required
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          1.14 What are you applying as?
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <RadioButtonGrid
            options={options_1_5}
            tooltips={tooltips_1_5}
            columns={1}
            name="applyingAs"
            formDataKey="applyingAs"
            value={formData.applicationDetails.applyingAs}
            onChange={(e) => handleChange(e, "applicationDetails")}
            error={showErrors ? errors["applicationDetails.applyingAs"] : ""}
          />
        </div>
      </div>
      {formData.applicationDetails.applyingAs.includes(
        "Non-Selling Principal",
      ) ? (
        <div>
          <div className="form-row">
            <div className="Content">
              1.15 What business areas will the appointed representative advise
              on? <span style={{ color: "var(--Error)" }}>*</span>
            </div>
            <div className="input-group">
              <CheckBoxGrid
                options={options_1_6}
                columns={1}
                name="businessAreas"
                formDataKey="businessAreas"
                selectedOptions={formData.applicationDetails.businessAreas}
                handleCheckboxChange={handleBusinessAresaCheckboxChange}
                error={
                  showErrors ? errors["applicationDetails.businessAreas"] : ""
                }
              />
            </div>
          </div>
        </div>
      ) : formData.applicationDetails.applyingAs.includes(
          "Selling Principal",
        ) ? (
        <>
          <div className="form-row">
            <div className="Content">
              1.15.1 What business areas will you advise on?{" "}
              <span style={{ color: "var(--Error)" }}>*</span>
            </div>
            <div className="input-group">
              <CheckBoxGrid
                options={options_1_6}
                columns={1}
                name="businessAreas"
                formDataKey="businessAreas"
                selectedOptions={formData.applicationDetails.businessAreas}
                handleCheckboxChange={handleBusinessAresaCheckboxChange}
                error={
                  showErrors ? errors["applicationDetails.businessAreas"] : ""
                }
              />
            </div>
          </div>
          <div className="form-row">
            <div className="Content">
              1.15.2 What business areas will the appointed representative
              advise on? <span style={{ color: "var(--Error)" }}>*</span>
            </div>
            <div className="input-group">
              <CheckBoxGrid
                options={options_1_6}
                columns={1}
                name="ARBusinessAreas"
                formDataKey="ARBusinessAreas"
                selectedOptions={formData.applicationDetails.ARBusinessAreas}
                handleCheckboxChange={handleARBusinessAreasCheckboxChange}
                error={
                  showErrors ? errors["applicationDetails.ARBusinessAreas"] : ""
                }
              />
            </div>
          </div>
        </>
      ) : formData.applicationDetails.applyingAs.includes("Adviser") ? (
        <div className="form-row">
          <div className="Content">
            1.15 What business areas will you advise on?
            <span style={{ color: "var(--Error)" }}>*</span>
          </div>
          <div className="input-group">
            <CheckBoxGrid
              options={options_1_6}
              columns={1}
              name="businessAreas"
              formDataKey="businessAreas"
              selectedOptions={formData.applicationDetails.businessAreas}
              handleCheckboxChange={handleBusinessAresaCheckboxChange}
              error={
                showErrors ? errors["applicationDetails.businessAreas"] : ""
              }
            />
          </div>
        </div>
      ) : null}
      <div className="input-group-row">
        <div className="Content">
          1.16 Are you applying to join:
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <RadioButtonGrid
            options={options_1_7}
            tooltips={tooltips_1_7}
            columns={1}
            name="applyingToJoin"
            value={formData.applicationDetails.applyingToJoin}
            onChange={(e) => handleChange(e, "applicationDetails")}
            error={
              showErrors ? errors[`applicationDetails.applyingToJoin`] : ""
            }
            required
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          Name of Appointed Representative or Trading Style
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <InputField
            id="tradingStyle"
            value={formData.applicationDetails.tradingStyle}
            placeholder=""
            error={showErrors && !!errors[`applicationDetails.tradingStyle`]}
            helperText={
              showErrors ? errors[`applicationDetails.tradingStyle`] : ""
            }
            onChange={(e) => handleChange(e, "applicationDetails")}
            required
          />
        </div>
      </div>
      <div className="Label-Small-SemiBold">
        This is very important - it is exactly what will be shown on the FCA
        Register
      </div>
      {/* <div className="input-group-row">
        <div className="Content">
          Will you be conducting Pension transfer business as part of your
          proposition?
        </div>
        <div className="input-group">
          <YesNoRadio
            name="pensionTransferBusiness"
            value={formData.applicationDetails.pensionTransferBusiness}
            error={
              showErrors
                ? errors[`applicationDetails.pensionTransferBusiness`]
                : ""
            }
            onChange={(e) => handleChange(e, "applicationDetails")}
            required
          />
        </div>
      </div> */}
      {/* <div className="input-group-row">
        <div className="Content">
          Will you be conducting Mortgage planning business as part of your
          proposition?
        </div>
        <div className="input-group">
          <YesNoRadio
            name="mortgagePlanningBusiness"
            value={formData.applicationDetails.mortgagePlanningBusiness}
            error={
              showErrors
                ? errors[`applicationDetails.mortgagePlanningBusiness`]
                : ""
            }
            onChange={(e) => handleChange(e, "applicationDetails")}
            required
          />
        </div>
      </div> */}
      <div className="input-group-row">
        <div className="Content">
          Have you ever referred business or Introduced business to another
          adviser?
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group">
          <YesNoRadio
            name="referredBusiness"
            value={formData.applicationDetails.referredBusiness}
            error={
              showErrors ? errors[`applicationDetails.referredBusiness`] : ""
            }
            onChange={(e) => handleChange(e, "applicationDetails")}
            required
          />
        </div>
      </div>
      <div className="input-group-row">
        <div className="Content">
          If yes, please provide us with further information on volumes and the
          types of business involved. (As of November 2021, the FCA
          authorisations team has informed us they require detailed information
          on this point. Please provide full details to avoid your application
          being unnecessarily delayed).
        </div>
        <div className="input-group">
          <InputField
            id="referredBusinessDetails"
            value={formData.applicationDetails.referredBusinessDetails}
            error={
              formData.applicationDetails.referredBusiness === true &&
              formData.applicationDetails.referredBusinessDetails.trim() === ""
            }
            helperText={
              formData.applicationDetails.referredBusiness === true &&
              formData.applicationDetails.referredBusinessDetails.trim() === ""
                ? "This field is required"
                : ""
            }
            onChange={(e) => handleChange(e, "applicationDetails")}
            multiline
            rows={4}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="Content">
          1.17 Next of Kin Details{" "}
          <span style={{ color: "var(--Error)" }}>*</span>
        </div>
        <div className="input-group input-group--grid-2col">
          <InputField
            id="kinName"
            name="name"
            placeholder="Full Name"
            value={formData.nextOfKinDetails.name}
            error={showErrors && !!errors[`nextOfKinDetails.name`]}
            helperText={showErrors ? errors[`nextOfKinDetails.name`] : ""}
            onChange={(e) => handleChange(e, "nextOfKinDetails")}
            required
          />
          <InputField
            id="relationship"
            name="relationship"
            placeholder="Relationship with next of kin"
            value={formData.nextOfKinDetails.relationship}
            error={showErrors && !!errors[`nextOfKinDetails.relationship`]}
            helperText={
              showErrors ? errors[`nextOfKinDetails.relationship`] : ""
            }
            onChange={(e) => handleChange(e, "nextOfKinDetails")}
            required
          />
          <InputField
            id="kinEmail"
            name="email"
            label="Email Address"
            placeholder="Email Address"
            type="email"
            value={formData.nextOfKinDetails.email}
            error={showErrors && !!errors[`nextOfKinDetails.email`]}
            helperText={showErrors ? errors[`nextOfKinDetails.email`] : ""}
            onChange={(e) => handleChange(e, "nextOfKinDetails")}
            required
          />
          <MobileNumberInput
            label="Home Telephone"
            value={formData.nextOfKinDetails.telephone}
            onChange={(phone) =>
              handleChange(
                {
                  target: {
                    name: "telephone",
                    value: phone || "",
                  },
                },
                "nextOfKinDetails",
              )
            }
            isRequired
            error={showErrors ? errors["nextOfKinDetails.telephone"] : ""}
          />
          <InputField
            id="kinAddress"
            name="address"
            placeholder="Address Line 1"
            value={formData.nextOfKinDetails.address}
            error={showErrors && !!errors[`nextOfKinDetails.address`]}
            helperText={showErrors ? errors[`nextOfKinDetails.address`] : ""}
            onChange={(e) => handleChange(e, "nextOfKinDetails")}
            required
          />
          <InputField
            id="kinPostcode"
            name="postcode"
            placeholder="Postcode"
            value={formData.nextOfKinDetails.postcode}
            error={showErrors && !!errors[`nextOfKinDetails.postcode`]}
            helperText={showErrors ? errors[`nextOfKinDetails.postcode`] : ""}
            onChange={(e) => handleChange(e, "nextOfKinDetails")}
            required
          />
          <InputField
            id="kinTown"
            name="town"
            placeholder="Town/City"
            value={formData.nextOfKinDetails.town}
            error={showErrors && !!errors[`nextOfKinDetails.town`]}
            helperText={showErrors ? errors[`nextOfKinDetails.town`] : ""}
            onChange={(e) => handleChange(e, "nextOfKinDetails")}
            required
          />
          <InputField
            id="kinCounty"
            name="county"
            placeholder="County"
            value={formData.nextOfKinDetails.county}
            error={showErrors && !!errors[`nextOfKinDetails.county`]}
            helperText={showErrors ? errors[`nextOfKinDetails.county`] : ""}
            onChange={(e) => handleChange(e, "nextOfKinDetails")}
            required
          />
        </div>
      </div>
      {!isSubmitted && <PrimaryButton label="SAVE" onClick={handleSubmit} />}
    </form>
  );
};
export default Section1;
